import React, { useMemo } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";

function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}

export default function OperatorPMSProfilesTable(props) {
    // Transform API data to DataGrid format
    const ruckusR1ControllersData = useMemo(() => {
        if (!props.ruckusR1Controllers || !Array.isArray(props.ruckusR1Controllers)) {
            return [];
        }
        
        return props.ruckusR1Controllers.map((profile, index) => ({
            id: index + 1, // DataGrid requires an id field
            ControllerName: profile.ControllerName,
            URL: profile.URL,
            TenantID: profile.TenantID,
            enableSync: profile.enableSync,
            dateModifiedUTC: profile.dateModifiedUTC,
            AvailableDPSKPools: profile.AvailableDPSKPools.length,
            originalProfile: profile, // Keep reference to original profile
        }));
    }, [props.ruckusR1Controllers]);

    const ruckusR1ControllersColumns = [
        {
            headerName: "Controller Name",
            field: "ControllerName",
            minWidth: 300
        },
        {
            headerName: "URL",
            field: "URL",
            minWidth: 150,
        },
        {
            headerName: "Tenant ID",
            field: "TenantID",
            minWidth: 150,
        },
        {
            headerName: "Sync Status",
            field: "enableSync",
            minWidth: 150,
        },
        {
            headerName: "Last Updated",
            field: "dateModifiedUTC",
            minWidth: 180,
            valueFormatter: (value) => {
                if (value) {
                    try {
                        const date = new Date(value);
                        return date.toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                        });
                    } catch (error) {
                        console.error('Date formatting error:', error, value);
                        return value;
                    }
                }
                return "";
            },
        },
        {
            headerName: "Available DP-SK Pools",
            field: "AvailableDPSKPools",
            minWidth: 180,
        },
        {
            headerName: "Action",
            field: "actions",
            minWidth: 300,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        <Button
                            onClick={(e) => {
                                e.stopPropagation();
                                if (props.modifyRuckusR1Controller) {
                                    props.modifyRuckusR1Controller(params.row.originalProfile);
                                }
                            }}
                            variant="outlined"
                            size="small"
                        >
                            Modify
                        </Button>
                        <Button
                            onClick={(e) => {
                                e.stopPropagation();
                                if (props.refreshRuckusR1Pools) {
                                    props.refreshRuckusR1Pools(params.row.originalProfile);
                                }
                            }}
                            variant="outlined"
                            size="small"
                            color="primary"
                        >
                            Refresh Pools
                        </Button>
                        <Button
                            onClick={(e) => {
                                e.stopPropagation();
                                if (props.deleteRuckusR1Controller) {
                                    props.deleteRuckusR1Controller(params.row.originalProfile);
                                }
                            }}
                            variant="outlined"
                            size="small"
                            color="error"
                        >
                            Delete
                        </Button>
                    </div>
                );
            },
        },
    ];

    // Show loading state
    if (props.loading) {
        return (
            <div style={{ height: 400, width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography>Loading Ruckus R1 Controllers...</Typography>
            </div>
        );
    }

    // Show empty state
    if (!props.ruckusR1Controllers || props.ruckusR1Controllers.length === 0) {
        return (
            <div style={{ height: 400, width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography>No Ruckus R1 Controllers found</Typography>
            </div>
        );
    }

    return (
        <div style={{ height: 400, width: "100%" }}>
            <DataGrid
                rows={ruckusR1ControllersData}
                columns={ruckusR1ControllersColumns}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                    },
                }}
                pageSizeOptions={[5, 10, 25]}
                slots={{ toolbar: QuickSearchToolbar }}
                disableRowSelectionOnClick
                sx={{
                    '& .MuiDataGrid-cell': {
                        fontSize: '0.875rem',
                    },
                    '& .MuiDataGrid-columnHeader': {
                        fontSize: '0.875rem',
                        fontWeight: 'bold',
                    },
                }}
            />
        </div>
    );
}